<template>
  <div class="container">
    <div class="main">
      <div class="left">
        <div class="cont">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="用户名" prop="pass">
              <el-input
                type="password"
                v-model="ruleForm.pass"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="checkPass">
              <el-input
                type="password"
                v-model="ruleForm.checkPass"
                autocomplete="off"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')"
                >提交</el-button
              >
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="right">
        <div class="bg"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("年龄不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value < 18) {
            callback(new Error("必须年满18岁"));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        pass: "",
        checkPass: "",
        age: ""
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        age: [{ validator: checkAge, trigger: "blur" }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  created() {},

  methods: {}
};
</script>

<style lang="less" scoped>
.container {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(45deg, #30e8bf, #40aabd);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  //   filter: blur(0.5rem);
  //   background: url("https://img.js.design/assets/img/61ce997213eb2456d8ed4d92.png")
  // background: url(https://img.js.design/assets/img/61ce997213eb2456d8ed4d92.png)
  //     no-repeat;
  //   background-size: 50% 100%;
  //   background-position-x: right;
  .main {
    width: 11.94rem;
    height: 5.97rem;
    min-width: 9.6rem;
    border-radius: 0.1rem;
    background: #fff;
    display: flex;
    overflow: hidden;

    .left {
      flex: 1;
      display: flex;
      padding: 1.03rem 0.86rem;
      box-sizing: border-box;
      .cont {
        flex: 1;
        box-sizing: border-box;
        // background: red;
      }
    }
    .right {
      flex: 1;

      background: black;
      display: flex;
      .bg {
        width: 100%;
        height: 100%;
        // background: red;
        background: url(https://img.js.design/assets/img/61ce997213eb2456d8ed4d92.png)
          no-repeat;
        background-position: 0, 0, 0, 2rem;
        background-size: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue